// Fetch Feedback Types
export const FETCH_FEEDBACK_REQUEST = 'FETCH_FEEDBACK_REQUEST';
export const FETCH_FEEDBACK_REQUEST_SUCCESS = 'FETCH_FEEDBACK_REQUEST_SUCCESS';
export const FETCH_FEEDBACK_REQUEST_FAILER = 'FETCH_FEEDBACK_REQUEST_FAILER';


// Create Feedback Types
export const CREATE_FEEDBACK_REQUEST = 'CREATE_FEEDBACK_REQUEST';
export const CREATE_FEEDBACK_REQUEST_SUCCESS = 'CREATE_FEEDBACK_REQUEST_SUCCESS';
export const CREATE_FEEDBACK_REQUEST_FAILER = 'CREATE_FEEDBACK_REQUEST_FAILER';

// Fetch listing dropdown
export const FETCH_LISITNG_DROPDOWN_REQUEST = 'FETCH_LISITNG_DROPDOWN_REQUEST';
export const FETCH_LISITNG_DROPDOWN_SUCCESS = 'FETCH_LISITNG_DROPDOWN_SUCCESS';
export const FETCH_LISITNG_DROPDOWN_FAILER = 'FETCH_LISITNG_DROPDOWN_FAILER';

